import {useContext, useEffect} from 'react'
import {DeviceContext, SELECT_DEVICE} from '../context/context'
import InputText from '../../../common/InputText'
import SelectInput from '../../../common/SelectInput'
import TextArea from '../../../common/TextArea'
import Button from '../../../common/Button'
import {useParams} from 'react-router-dom'
import {postRequest, putRequest} from '../../../../services/base'
import {NavContext} from '../../../../context/global_context'
import {Col, Flex, Form, Modal, Row} from 'antd'
import {useIntl} from 'react-intl'
import {toTitleCase} from '../../../../utils/common'

const DeviceFormModal = (props) => {
  const intl = useIntl()
  let { vehicle } = useParams()

  const [state, dispatch] = useContext(DeviceContext)
  const [, navDispatch] = useContext(NavContext)

  const [form] = Form.useForm()

  // Merge the device's current category into options when editing a device
  // whose category is not part of the API list
  const selectedCategory = state?.selected_device?.category
  const options =
    selectedCategory &&
    !props.categoryOptions?.some((option) => option.value === selectedCategory)
      ? [
          ...(props.categoryOptions || []),
          { value: selectedCategory, label: toTitleCase(selectedCategory) },
        ]
      : props.categoryOptions || []

  const closeFormPopup = () => {
    dispatch({
      type: SELECT_DEVICE,
      data: { selected_device: {}, show_device_popup: false },
    })
    form.resetFields()
  }

  const saveDevice = async (values) => {
    const formData = new FormData()
    Object.entries(values).forEach(([key, value]) => {
      if (key === 'alias') return
      if (Array.isArray(value) && value.length > 0) {
        value.forEach((item) => {
          if (item && typeof item === 'object' && item.value !== undefined) {
            formData.append(key, item.value)
          } else if (item !== undefined && item !== null) {
            formData.append(key, item)
          }
        })
      } else if (value && typeof value === 'object' && value.value !== undefined) {
        formData.append(key, value.value)
      } else if (value !== undefined && value !== null) {
        formData.append(key, value)
      }
    })
    formData.append('vehicle', vehicle)

    // Always send alias (entered value or empty string)
    formData.append('alias', String(values.alias || '').trim())

    let res = null
    if (state?.selected_device?.id) {
      res = await putRequest(
        `/api/devices/${state?.selected_device?.id}/?vehicle=${vehicle}`,
        formData
      )
    } else {
      res = await postRequest(`/api/devices/`, formData)
    }

    if (res?.status) {
      navDispatch({
        type: 'notification',
        data: {
          notification_type: 'success',
          msg: state?.selected_device?.id
            ? intl.formatMessage({ id: 'devices.updateSuccess' })
            : intl.formatMessage({ id: 'devices.saveSuccess' }),
        },
      })
      props.getListData()
      closeFormPopup()
    } else {
      navDispatch({
        type: 'notification',
        data: {
          notification_type: 'error',
          msg: intl.formatMessage({ id: 'devices.saveError' }),
        },
      })
    }
  }

  // Initialize form when modal opens
  useEffect(() => {
    if (!state.show_device_popup) return
    const mod = state?.selected_device || {}
    form.setFieldsValue({
      name: mod.name || null,
      category: mod.category || null,
      description: mod.description || null,
      alias: mod.alias?.value || null,
    })
  }, [state.show_device_popup])

  return (
    <Modal
      open={state.show_device_popup}
      title={intl.formatMessage({ id: 'devices.deviceDetails' })}
      width="50%"
      className="devices-form-modal"
      centered={true}
      footer={null}
      closable={true}
      onCancel={closeFormPopup}
    >
      <div className="container">
        <Form
          id="device-form"
          name="device-form"
          form={form}
          layout="vertical"
          onFinish={saveDevice}
        >
          <Row gutter={[16, 16]}>
            <Col span={12}>
              <InputText
                name="name"
                label={intl.formatMessage({ id: 'devices.name' })}
                isRequired={true}
                errorHelp={false}
              />
            </Col>

            <Col span={12}>
              <SelectInput
                name="category"
                label={intl.formatMessage({ id: 'devices.category' })}
                options={options}
                placeholder={intl.formatMessage({ id: 'devices.category' })}
                isRequired={false}
                allowClear={true}
                showSearch={true}
              />
            </Col>

            <Col span={24}>
              <TextArea
                name="description"
                label={intl.formatMessage({ id: 'devices.description' })}
                isRequired={false}
              />
            </Col>

            <Col span={24}>
              <InputText
                name="alias"
                label={intl.formatMessage({ id: 'devices.alias' })}
                isRequired={false}
              />
            </Col>

            <Col span={24}>
              <Flex justify="end" className="py-4">
                <Button htmlType="submit" type="primary">
                  {intl.formatMessage({ id: 'devices.save' })}
                </Button>
              </Flex>
            </Col>
          </Row>
        </Form>
      </div>
    </Modal>
  )
}

export default DeviceFormModal
